"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLocalizedContent = void 0;
const validateLocalizedContent = (enableAddToList, addToListLocalizedContent, enableSkuSelector, skuSelectorLocalizedContent) => {
    if (enableAddToList && !addToListLocalizedContent) {
        const errorMessage = 'Add to list localized content is not available';
        console.error(errorMessage);
        return new Error(errorMessage);
    }
    if (enableSkuSelector && !skuSelectorLocalizedContent) {
        const errorMessage = 'Sku selector localized content is not available';
        console.error(errorMessage);
        return new Error(errorMessage);
    }
};
exports.validateLocalizedContent = validateLocalizedContent;
